
import React, { useEffect, useState } from 'react';
import { TextField, Typography, Button, Container, Grid } from '@mui/material';
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from 'react-router-dom';
import { useSaveChapterRewardMutation, useLazyGetchapterRewardByIdQuery, useUpdatechapterRewardMutation } from '../../../app/services/chapterRewardsService';
import { toast } from "react-toastify";
import Spinner from "../../../Component/spinner/spinner";
import { useSelector } from 'react-redux';
import { selectCurrentScope } from "../../../app/auth/authSlice";
import ImageCropModal, { useImageCrop } from '../../../Component/ImageCropModal/ImageCropModal';

const AddEditChapterReward = () => {
    const { register, watch, handleSubmit, setValue, reset, formState: { errors } } = useForm({
        defaultValues: { uploadImage: '' },
    });
    const [saveChapterReward] = useSaveChapterRewardMutation();
    const [getChapterRewardById] = useLazyGetchapterRewardByIdQuery();
    const [UpdateChapterReward] = useUpdatechapterRewardMutation();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();

    const memberScope = useSelector(selectCurrentScope);
    const [selectedFile, setSelectedFile] = useState(null);

    // Crop modal hook — output 150×150 px (midpoint of 140–160)
    const { cropModal, openCropModal, handleCropApply, closeCropModal } = useImageCrop();

    // Called after user finishes cropping
    const onCropDone = (base64) => {
        setSelectedFile(base64);
        setValue("uploadImage", base64);
    };

    // Save partner
    const onsaveChapterReward = (data) => {
        setLoading(true);

        // Regex to check if logo is a base64 string
        const base64Regex = /^data:image\/(?:png|jpeg|jpg|gif);base64,[\w+/=]+$/;

        // Validate the logo and ensure it is either base64 or a URL
        const uploadImage = base64Regex.test(data?.uploadImage)
            ? data?.uploadImage
            : typeof data?.uploadImage === 'string' ? data?.uploadImage.split("/").slice(-2).join("/") : '';

        // Prepare partner data
        const ChapterRewardsData = {
            uploadImage: selectedFile || uploadImage, // Ensure logo is correctly assigned
            id: data._id,
        };
        // Determine the save action (update or create)
        const saveAction = id ? UpdateChapterReward(ChapterRewardsData) : saveChapterReward(ChapterRewardsData);

        // Execute the save action
        saveAction
            .then((res) => {
                if (res?.data?.status) {
                    toast.success(id ? "ChapterRewardsData Updated Successfully!!!" : "ChapterRewardsData Created Successfully!!!");
                    reset();
                    navigate(getRedirectPath());
                } else {
                    toast.error(res?.data?.err?.message || "An error occurred.");
                }
                setLoading(false);
            })
            .catch((err) => {
                toast.error("Error occurred while saving partner.");
                setLoading(false);
                console.error(err);
            });
    };



    // Get redirect path based on user scope
    const getRedirectPath = () => {
        if (memberScope === "PORTAL_SUPER_ADMIN") return "/admin/chapter-rewards-table";
    };

    // Get data for editing
    useEffect(() => {
        if (id) {
            getChapterRewardById(id).then((res) => {
                if (res?.data?.status) {
                    setSelectedFile(res?.data?.data?.uploadImage);
                    Object.entries(res?.data?.data).forEach(([key, value]) => {
                        setValue(key, value);
                    });
                }
            });
        }
    }, [getChapterRewardById, id, setValue]);


    return (
        <>
            <div className="pt-5">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">{id ? "Edit Chaper Reward" : "Add  Chaper Reward"}</h2>
                </div>
            </div>
            <Container maxWidth={'xxl'} className='p-md-5 p-3 overallPadding'>
                <div className='w-100 text-end mb-3'>
                    <Button
                        onClick={() => window.history.back()}
                        variant="contained"
                        className="menus-color"
                    >
                        Back
                    </Button>
                </div>
                {loading ? <Spinner /> : (
                    <form className='w-100 p-0 m-0' onSubmit={handleSubmit(onsaveChapterReward)}>
                        <div className='d-flex justify-content-center'>
                            {id ? (
                                selectedFile && (
                                    <>
                                        <img
                                            src={selectedFile}
                                            alt="Logo Preview"
                                            height="150"
                                            className="img-responsive"
                                        />
                                        <input
                                            accept="image/jpeg, image/png"
                                            id="thumbnailImage"
                                            type="file"
                                            style={{ display: "none" }}
                                            onChange={(e) => openCropModal(e)}
                                        />
                                        <div className="d-flex justify-content-center align-items-center">
                                            <label
                                                htmlFor="thumbnailImage"
                                                style={{ marginLeft: "10px" }}
                                            >
                                                <Button
                                                    variant="contained"
                                                    className="menus-color border-radius-membership-wallpage-button mt-2"
                                                    component="span"
                                                    style={{ whiteSpace: "nowrap" }}
                                                >
                                                    Choose File
                                                </Button>
                                            </label>
                                        </div>
                                    </>
                                )
                            ) : (
                                <div className='d-flex flex-column align-items-center w-100 gap-2'>
                                    {/* Image preview for Add mode */}
                                    {(selectedFile || watch("uploadImage")) && (
                                        <div className="d-flex justify-content-center w-100 mb-2">
                                            <img
                                                src={selectedFile || watch("uploadImage")}
                                                alt="Reward Img"
                                                height="150"
                                                className="img-responsive"
                                                style={{ objectFit: "scale-down" }}
                                            />
                                        </div>
                                    )}
                                    <TextField
                                        InputLabelProps={{ shrink: true }}
                                        style={{ width: "50%" }}
                                        inputProps={{ accept: "image/jpeg, image/png" }}
                                        id="thumbnailImage"
                                        label={
                                            <Typography className="text-dark">
                                                Upload Image <span style={{ color: "red" }}>*</span>
                                            </Typography>
                                        }
                                        variant="outlined"
                                        type="file"
                                        {...register("image", {
                                            required: { value: !watch('uploadImage'), message: 'Please select an image' },
                                            onChange: (e) => openCropModal(e),
                                        })}
                                        error={!!errors?.image}
                                        helperText={errors?.image?.message}
                                    />
                                </div>
                            )}
                        </div>

                        <div className='d-flex justify-content-center mt-5'>
                            <Grid item xs={12} className='text-center'>
                                <Button variant="contained" className="menus-color mb-5" type="submit" sx={{ mr: 3 }}>
                                    {id ? "Update" : "Submit"}
                                </Button>
                            </Grid>
                        </div>
                    </form>
                )}
            </Container>

            {/* Image Crop Modal — crops to 150×150 px */}
            <ImageCropModal
                open={cropModal.open}
                imageSrc={cropModal.src}
                onCancel={closeCropModal}
                onCrop={(base64) => handleCropApply(base64, onCropDone)}
                outputWidth={150}
                outputHeight={150}
                title="Crop Reward Image (150 × 150 px)"
            />
        </>
    );
};

export default AddEditChapterReward;

